import { takeLeading } from 'redux-saga/effects';
import {
    CHANGE_LANGUAGE,
    REFRESH_DATA,
} from '../../actions/actionTypes';
import { translate } from '../../shared/translations';

export function* changeLanguage(action) {
    const lang = action.language;
    const changeLanguageResult = yield fetch(`/ajaxcontroller/changeLanguage/${lang}`);
    if (!changeLanguageResult.error) {
        document.cookie = `LOCALE=${lang}`;
        window.location.reload();
    } else {
        // eslint-disable-next-line no-alert
        alert(`${translate('language_change_alert')}. \n(${changeLanguageResult.error})`);
    }
}

export function* clearMVCache() {
    const clearMVCacheResult = yield fetch('/ajaxcontroller/clearMVCache');
    if (!clearMVCacheResult.error) {
        // TODO stop using alert and get a real modal
        // eslint-disable-next-line no-alert
        alert(translate('data_refresh_alert'));
        window.location.reload();
    } else {
        // eslint-disable-next-line no-alert
        alert(translate('error_refreshing_data'));
    }
    return false;
}

export default function* watchUserDropdownSaga() {
    yield takeLeading(REFRESH_DATA, clearMVCache);
    yield takeLeading(CHANGE_LANGUAGE, changeLanguage);
}
